import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import AddressesContext from './AddressesContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const AddressesProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <AddressesContext.Provider value={{ actions, selectors, state }}>
      {children}
    </AddressesContext.Provider>
  );
};

export default AddressesProvider;
